/**
 * Shared constants for landing-page components.
 * Single source of truth for API base, platform URL, and Shopify App Store URL.
 */
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const PLATFORM_URL = "https://platform.aigrowthoperator.xyz";
export const SHOPIFY_APP_STORE_URL = PLATFORM_URL;
